import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { Close as CloseIcon, WarningAmber as WarningAmberIcon } from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import { accentInk, contrastTextColor, type TenantAppearance } from '../../utils/tenantAppearance';

const TENANT_AVISO_HEIGHT = 32;

const DEFAULT_AVISO_COLOR = '#d97706';

interface TenantAvisoEntornoBannerProps {
  appearance: TenantAppearance;
  tenantName: string | null;
  visible: boolean;
  onClose: () => void;
}

const TenantAvisoEntornoBanner: React.FC<TenantAvisoEntornoBannerProps> = ({
  appearance,
  tenantName,
  visible,
  onClose,
}) => {
  if (!visible) return null;

  const color = appearance.colorAcento ?? DEFAULT_AVISO_COLOR;
  const textColor = contrastTextColor(color);
  const ink = accentInk(color);

  return (
    <Box
      role="status"
      className="app-tenant-aviso"
      sx={{
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        boxShadow: '0 2px 6px rgba(0,0,0,0.18)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        height: TENANT_AVISO_HEIGHT,
        pl: 2,
        pr: 6,
        boxSizing: 'border-box',
        bgcolor: color,
        color: textColor,
        borderTop: ink !== color ? `1px solid ${alpha(ink, 0.35)}` : undefined,
        borderBottom: ink !== color ? `1px solid ${ink}` : undefined,
      }}
    >
      <WarningAmberIcon fontSize="small" sx={{ flexShrink: 0 }} />
      <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 0 }} noWrap>
        Estás operando en {appearance.etiqueta ? <strong>{appearance.etiqueta}</strong> : 'esta empresa'}
        {tenantName ? ` · ${tenantName}` : ''}
      </Typography>
      <Tooltip title="Ocultar aviso en esta pestaña">
        <IconButton
          size="small"
          aria-label="Ocultar aviso"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            color: 'inherit',
            p: 0.25,
            '&:hover': { bgcolor: 'rgba(0,0,0,0.12)' },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default TenantAvisoEntornoBanner;
